/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Organization = zod
	.object({
		created_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		id: zod.uuid().describe('Organization ID'),
		name: zod.string().describe('Organization name'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('An organization');

export type Organization = zod.input<typeof Organization>;
export type OrganizationOutput = zod.output<typeof Organization>;
